import { RouteObject } from "react-router"
import { ItemList } from "./item.view"
import { rotas,menuRotas } from "../../services/router"
import { MainMenu } from "../../data.types"
import { Widgets } from "@mui/icons-material"

export enum PathRotaItem {
    item = "/item"
}

const routerItem: RouteObject = {
    path: PathRotaItem.item,
    element: <ItemList/>,
}


export const navigationToItemView = ()=> rotas.navigate(PathRotaItem.item)

export function startRouterItem(){
    const menu:MainMenu = {
        text:"Itens",
        icon:<Widgets />,
        eventOnClick:navigationToItemView
    }
    menuRotas.push(menu);
    return routerItem
}